(function (app) {
  $(document).ready(function () {

    app.ImageUploader = function (options) {
      var _this = this;
      _this.options = $.extend({'maxFiles': 1, imageSelection: 'single'}, options);
      _this.getUrl = '/api/image/user';

      var nameSpace = 'ImageUploader' + _this.id,
        context = '.page__image_uploader--context',
        templates = {
          'imageRow': app.templates["Image__manager____uploader-row"]
        },
        defaultPageParams = {
          'pageSize': 30,
          'pageNo': 1,
          'q': '96d6f2e7e1f705ab5e59c84a6dc009b2', //md5('logo')
          'orderBy': 'dateCreated',
          'orderByOrder': "DESC",
        }
        ;

      _this.storage = function () {
        return $.sessionStorage;
      }();

      _this.getDefaultPageParams = function () {
        return $.extend({}, {
          'orderBy': _this.dataTable.attr('data-orderBy'),
          'orderByOrder': _this.dataTable.attr('data-orderByOrder')
        }, defaultPageParams);
      };

      _this.pageParams = function () {
        var key = nameSpace + '__pageParams';
        return {
          set: function (params) {
            var pageParams = $.extend({}, _this.storage.get(key), params);
            _this.storage.set(key, pageParams);
          },
          get: function () {
            return _this.storage.get(key);
          },
          reset: function () {
            var defaultPageParams = _this.getDefaultPageParams();

            var pageParams = $.extend({}, _this.storage.get(key), defaultPageParams);
            _this.storage.set(key, pageParams);
          }
        }
      };

      _this.initModal = function () {
        _this.modal = $(app.templates["Image__manager____modal-uploader"]);
        $('body').append(_this.modal);

        _this.id = _this.modal.assignId();
        _this.$modal = $('#' + _this.id);
      };

      _this.destroyModal = function () {
        $('[data-modal-image-uploader]').remove();
      };


      _this.destroy = function () {
        _this.destroyModal();
      };

      _this.initMasonry = function () {
        var $grid = $('.grid__container', _this.$modal).find('.grid__wrapper');
        if ($grid.length) {
          $grid.remove();
        }

        var windowHeight = $('.modal-content', _this.$modal).height() - 100;
        _this.wrapper = $('<div class="grid__wrapper m-progress"> </div>').prependTo($('.grid__container', _this.$modal)).height(windowHeight);
        _this.dataTable = $('<div class="grid" > <div class="grid-sizer"></div> </div>').appendTo(_this.wrapper);
        _this.grid = _this.dataTable.masonry({
          itemSelector: '.grid-item',
          columnWidth: '.grid-sizer',
          percentPosition: true,
        });
      };

      _this.initInfiniteScroll = function () {
        var $paginationId = $('.pagination__next', _this.modal).attr('href', _this.buildUrl({pageNo: 2})).assignId();

        var $modalBody = $('.grid__wrapper', _this.$modal);

        if (_this.infiniteScroll) {
          _this.infiniteScroll.infiniteScroll('destroy');
        }

        _this.infiniteScroll = $modalBody.infiniteScroll({
          path: '#' + $paginationId,
          append: false,
          history: false,
          checkLastPage: false,
          elementScroll: true
        });

        _this.infiniteScroll.on('load.infiniteScroll', function (event, response, path) {
          _this.updateList(response);
          $('.grid__loader', _this.$modal).hide();
        });

        _this.infiniteScroll.on('request.infiniteScroll', function (event, path) {
          $('.grid__loader', _this.$modal).show();
        });
      };

      _this.buildUrl = function (options) {
        options = $.extend({}, _this.pageParams().get(), options);

        // Customize below as per backend params required
        var queryBuilders = [];
        queryBuilders.push('page=' + options.pageNo);
        queryBuilders.push('limitPerPage=' + options.pageSize);
        !_.isEmpty(options.q) ? queryBuilders.push('q=' + options.q) : '';
        !_.isEmpty(options.type) ? queryBuilders.push('type=' + options.type) : '';
        !_.isEmpty(options.orderBy) ? queryBuilders.push('orderBy=' + options.orderBy + '&orderByOrder=' + options.orderByOrder) : '';
        !_.isEmpty(options.query) ? queryBuilders.push('query=' + options.query + '&' + $.param(options.queryParams)) : '';

        return _this.getUrl + encodeURI('?' + queryBuilders.join('&'));
      };

      _this.imageActions = function () {
        return {
          delete: function (imageId) {
            var query = $.Deferred();
            var appTransport = app.transport();
            appTransport
              .setEvent('onSuccess', function (response) {
                if (_.isEmpty(response)) {
                  app.flashMessenger('error', 'Empty response');
                  return query.reject(response);
                } else {
                  app.flashMessenger('success', response.message);
                  return query.resolve(response);
                }
              })
              .setEvent('onError', function (error) {
                app.flashMessenger('error', error.code + ' :: ' + error.message.message);
                return query.reject(error);
              })
              .setEvent('onComplete', function () {

              })
            ;
            appTransport.delete('/api/image/user/' + imageId);
            return query.promise();
          }
        }
      };

      // To update Table view
      _this.updateList = function (response) {
        if (typeof response.result != 'undefined' && response.result.length) {
          _.each(response.result, function (row) {
            var imageRow = _.template(templates.imageRow);

            var $imageRow = $(
              imageRow(
                $.extend(row, {
                  selectable: _this.options['imageSelection'],
                  deletable: _.isUndefined(row.deletable) ? false : row.deletable,
                  favorite: _.isUndefined(row.favorite) ? false : row.favorite
                })
              )
            );
            $imageRow.appendTo(_this.dataTable);
            _this.grid.append($imageRow).masonry('appended', $imageRow);
          });
        } else {
          if ($('.grid-item', _this.$modal).length == 0) {
            $('.grid__no-result', _this.$modal).show();
          }
        }
        setTimeout(function () {
          app.lazyLoadImage(_this.dataTable, function (element) {
            var imageSrc = element.data('src');
            element.parent().removeClass('m-progress');
            element.parent().find('.image__actions').addClass('show');
            _this.grid.masonry('layout');
          });
        }, 300);

      };

      _this.get = function (options) {
        $('.grid__no-result', _this.$modal).hide();
        var query = $.Deferred();
        var appTransport = app.transport();

        appTransport
          .setEvent('onSuccess', function (response) {
            _this.wrapper.removeClass('m-progress');
            _this.updateList(response);
            return query.resolve(response);
          })
          .setEvent('onError', function (error) {
            //_this.updateList(_this.fakeImages());
            app.flashMessenger('error', error.code + ' :: ' + error.message.message);
            return query.resolve(error);
          })
          .setEvent('onComplete', function () {

          })
        ;
        appTransport.get(_this.buildUrl(options));
        return query.promise();
      };

      _this.init = function () {
        _this.initModal();
        _this.dataTable = _this.$modal.find('.grid');

        _this.pageParams().reset();
        _this.initMasonry();
        _this.initInfiniteScroll();

        $.when(_this.get()).done(function (response) {

        }).fail(function (response) {

        });

        // Modal On show Hide
        _this.$modal.on('shown.bs.modal', function (e) {

          $('[data-dropzone]', _this.$modal)
            .dropzone({
              acceptedFiles: 'image/jpg, image/jpeg, image/png, image/gif',
              url: "/api/image/user",
              maxFilesize: 10, // MB,
              timeout: 0,
              parallelUploads: 1,
              maxFiles: _this.options.maxFiles,
              complete: function (file) {
                // Only used for GI
                var logKey = '/api/image/user__POST';
                window['__gites'][logKey] = {
                  'status': file.xhr.status,
                  'response': file.xhr.response,
                  'url': '/api/image/user'
                };
                if (file.status == 'success' && _this.options.completeCallback) {
                  var response = JSON.parse(file.xhr.response);
                  _this.options.completeCallback(_this.modal, {images: [response]});
                }
              },
              queuecomplete: function (e) {
                $('.uploading-message', _this.$modal).hide();
              },
              sending: function (file, xhr, formData) {
                $('.uploading-message', _this.$modal).show();
                formData.append("keywords", _this.getDefaultPageParams()['q']);
              }
            });
        }).on('hidden.bs.modal', function (e) {
          _this.destroy();
          $('.modal-backdrop').remove();
          if (_this.options.hiddenCallback) {
            _this.options.hiddenCallback();
          }
        });

        _this.$modal.modal('show');


        $(document) // Actions ::  remove
          .off('click.actions__' + nameSpace).on('click.actions__' + nameSpace, context + ' [data-action]', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var action = $(this).attr('data-action'),
              $button = $(this),
              $dataRow = $(this).closest('[data-row]'),
              imageId = $dataRow.attr('data-row'),
              $context = $(context);

            switch (action) {

              case 'delete' :
                $button.addClass('m-progress');
                $.when(_this.imageActions().delete(imageId)).done(function () {
                  $button.removeClass('m-progress');
                  _this.grid.find('*').remove();
                  $.when(_this.get()).done(function (response) {

                  }).fail(function (response) {

                  });
                }).fail(function () {
                  $button.removeClass('m-progress');
                });
                break;


              case 'select' :
                if (_this.options.completeCallback) {
                  var imageUrls = _.map($dataRow.find('.image__item'), function (el) {
                    return {
                      'id': $(el).attr('data-id'),
                      'path': $(el).find('img').attr('data-url'),
                      'pathThumbnail': $(el).find('img').attr('data-thumbnail'),
                      'dimensions': $(el).find('img').attr('data-dimensions'),
                    };
                  });
                  _this.options.completeCallback(_this.modal, {images: imageUrls});
                }
                break;
            }
          });
      };

      return {
        show: function () {
          _this.init();
        }
      };
    };
  });
})(PreBuilt);
